module.exports = "/dist/assets/images/minus-white.svg";